import { setKey, geocode, RequestType, GeocodeOptions } from 'react-geocode';
import { GOOGLE_MAPS_API_KEY } from './config';

export const getAddressFromCoordinates = (lat: number, long: number) => {
  setKey(GOOGLE_MAPS_API_KEY);
  return geocode(RequestType.LATLNG, `${lat},${long}`, <GeocodeOptions>{
    location_type: 'ROOFTOP',
    enable_address_descriptor: true,
  })
    .then(({ results }) => {
      const addressComponents = results[0].address_components;
      const number = addressComponents.filter((entry) =>
          entry?.types?.includes('street_number')
        )[0].short_name,
        route = addressComponents.filter((entry) =>
          entry?.types?.includes('route')
        )[0].short_name,
        street = `${number} ${route}`,
        city = addressComponents.filter((entry) =>
          entry?.types?.includes('locality')
        )[0].short_name,
        state = addressComponents.filter((entry) =>
          entry?.types?.includes('administrative_area_level_1')
        )[0].short_name,
        zip = addressComponents.filter((entry) =>
          entry?.types?.includes('postal_code')
        )[0].short_name,
        country = addressComponents.filter((entry) =>
          entry?.types?.includes('country')
        )[0].short_name;

      return {
        street,
        city,
        state,
        zip,
        country,
      };
    })
    .catch(console.error);
};
